// extracted by mini-css-extract-plugin
export default {"categories-container":"Home_categories-container__XqtUQ"};